export function getEnvironmentFromHost(host = window.location.host) {
  const h = host.toLowerCase();
 
  if (h.includes('localhost')) return 'dev';
  if (h.includes('qa')) return 'qa';
  if (h.includes('int')) return 'int';
  if (h.includes('stg') || h.includes('stage')) return 'stg';
  if (h.includes('perf')) return 'perf';
  if (h.includes('csb')) return 'csb';
 
  return 'prod';
}
export function getClientIdFromHostname(input = window?.location?.hostname,environment) {
  if (!input || typeof input !== 'string') return null;
 
  const upperEnv = environment.toUpperCase();
  const envClientId = process.env.REACT_APP_CLIENTID;
  //For DEV and QA
  if (upperEnv == "DEV" || upperEnv == "QA") {
    return envClientId;
  }
  let hostname;
  try {
    // Try full URL
    const url = new URL(input);
    hostname = url.hostname;
  } catch {
    // Fallback to cleaning a hostname-ish string
    hostname = (input || '')
      .replace(/^\s*https?:\/\//i, '')
      .replace(/\/.*$/, '')
      .replace(/:\d+$/, '');
  }
 
  if (!hostname) return null;
 
  const parts = hostname.split('.').filter(Boolean);
  if (parts.length < 2) return null; 
 
  const firstLabel = parts[0];          
  const dashIdx = firstLabel.indexOf('-');
  const clientIdLabel = dashIdx >= 0 ? firstLabel.slice(0, dashIdx) : firstLabel;
  const clientId = clientIdLabel.toLocaleUpperCase();
 
  return `${envClientId}${clientId}`; 
}
export const getClientLobRoles = (actionArray) => {
    return actionArray.reduce((acc, action) => {
      if (action) {
        const [client, lob, role] = action.split(':');
  
        if (!acc[client]) {
          acc[client] = {};
        }
  
        if (!acc[client][lob]) {
          acc[client][lob] = [];
        }
  
        acc[client][lob].push(role);
      }
  
      return acc;
    }, {});
  };
export const createUser = (user) => {
    return {
      userEmail: user.email,
      firstName: user.given_name,
      lastName: user.family_name,
      userName: user.name,
      clientLobRoles: getClientLobRoles(user.group),
      isAuthenticated: true,
    };
  };
export const updateUser = (user) => {
    if (Boolean(user)) {
      sessionStorage.setItem('FrUser', JSON.stringify(user));
    }
  };